module.exports = __webpack_public_path__ + "static/media/H.E.Fondu.352d334e.jpg";